function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M19.187 6.813A8.75 8.75 0 106.813 19.187 8.75 8.75 0 0019.187 6.813zM5.045 5.045c4.393-4.393 11.517-4.393 15.91 0 4.095 4.095 4.373 10.56.835 14.978l8.134 8.134a.65.65 0 010 .919l-.848.848a.65.65 0 01-.92 0l-8.133-8.134c-4.418 3.538-10.883 3.26-14.978-.835-4.393-4.393-4.393-11.517 0-15.91z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M9.6 13a.65.65 0 01.65.65v3.7a.65.65 0 01-.65.65H8.4a.65.65 0 01-.65-.65v-3.7A.65.65 0 018.4 13h1.2z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.75 8.65A.65.65 0 0112.4 8h1.2a.65.65 0 01.65.65v8.7a.65.65 0 01-.65.65h-1.2a.65.65 0 01-.65-.65v-8.7z",
  fill: "url(#analysis_svg__paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6 10a.65.65 0 01.65.65v6.7a.65.65 0 01-.65.65h-1.2a.65.65 0 01-.65-.65v-6.7a.65.65 0 01.65-.65h1.2z",
  fill: "url(#analysis_svg__paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6 10a.65.65 0 01.65.65v6.7a.65.65 0 01-.65.65h-1.2a.65.65 0 01-.65-.65v-6.7a.65.65 0 01.65-.65h1.2z",
  fill: "url(#analysis_svg__paint2_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "analysis_svg__paint0_linear",
  x1: 12.219,
  y1: 8,
  x2: 14.265,
  y2: 8.117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "analysis_svg__paint1_linear",
  x1: 16.219,
  y1: 10,
  x2: 18.261,
  y2: 10.146,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "analysis_svg__paint2_linear",
  x1: 16.219,
  y1: 10,
  x2: 18.261,
  y2: 10.146,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgAnalysis = function SvgAnalysis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default SvgAnalysis;